import { BaseModal } from "../../../../common/components/BaseModal/BaseModal";
import { PrimaryDeleteButton, SecondaryButton } from "../../../../common/components/buttons/NewButtons.styles";
import { useState } from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { useStore } from "../../../app/data/root.store";
import { useTrackEvent } from "../../../../hooks/useTrackEvent/useTrackEvent";
import { useAnalytics } from "../../../app/data/AnalyticsProvider";
import { EraseIconWhite, VaultDeleteModalBody, VaultDeleteModalBodyContent, VaultDeleteModalMainText, VaultDeleteModalSecondaryText, VaultSuccessModalFooter } from "./VaultDeleteModal.styles";
import { VaultEraseIcon } from "../../assets/icons";
import { VaultModalHeader } from "../VaultModalHeader/VaultModalHeader";

export const VaultDeleteModal = (props) => {
    const { userStore } = useStore();
    const { onClose, onDelete } = props;
    const [isDeleting, setIsDeleting] = useState(false);
    const { trackEvent } = useAnalytics();

    const onDeleteFile = async () => {
        trackEvent('CTA Clicked', {
            cta_text: 'Cancel and Delete Upload',
            location: 'Magic box ai deep analysis results',
            destination: 'delete upload',
            type: "Button",
            url: window.location.href
        });
        setIsDeleting(true);
        await onDelete();
        setIsDeleting(false);
        onClose();

    };

    const onContinue = () => {
        trackEvent('CTA Clicked', {
            cta_text: 'Continue with Analysis',
            location: 'Magic box ai deep analysis results',
            destination: 'continue analysis',
            type: "Button",
            url: window.location.href
        });
        onClose();
    }

    useTrackEvent('Popup Viewed', {
        title: 'Cancel Document Upload.',
        url: window.location.href
    })

    return (
        <BaseModal borderRadius={8} width={'520px'} height={'auto'} noSidebarMargin={userStore.isWelcome}>
            <VaultModalHeader onClose={onClose} showSecuredButton={false} />
            <VaultDeleteModalBodyContent>
                <VaultDeleteModalBody>
                    <VaultEraseIcon />
                    <VaultDeleteModalMainText>Are you sure you want to cancel the document analysis?</VaultDeleteModalMainText>
                    <VaultDeleteModalSecondaryText>If you cancel now, the uploaded file and all its data will be deleted, and no assets will be created in your Vyzer portfolio.</VaultDeleteModalSecondaryText>
                </VaultDeleteModalBody>
            </VaultDeleteModalBodyContent>
            <VaultSuccessModalFooter>
                <SecondaryButton onClick={onContinue}>Continue with Analysis</SecondaryButton>
                <PrimaryDeleteButton onClick={onDeleteFile} style={{ minWidth: '250px' }}>
                    {isDeleting ? <LoadingOutlined /> :
                        <>
                            <EraseIconWhite />
                            Cancel and Delete Upload
                        </>}
                </PrimaryDeleteButton>
            </VaultSuccessModalFooter>
        </BaseModal>
    );
};